var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            id: "share-proof-video-from-fb",
            "modal-class": "share-video-proof-modal",
            "content-class": "share-video-proof-modal__content",
            "body-class": "share-video-proof-modal__body",
            "hide-header": "",
            "hide-footer": "",
            centered: "",
            "no-close-on-backdrop": "",
          },
          on: { show: _vm.onShow, hide: _vm.onHide },
        },
        [
          _c(
            "div",
            { staticClass: "share-video-proof-modal__panel" },
            [
              _c("div", { staticClass: "share-video-proof-modal__header" }, [
                _c("h2", { staticClass: "share-video-proof-modal__title" }, [
                  _vm._v(
                    "\n          Share " +
                      _vm._s(_vm.isGifProof ? "GIF" : "Video") +
                      " Proof\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "share-video-proof-modal__close",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M18 6 6 18" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "m6 6 12 12" } }),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.isSharing
                ? _c(
                    "div",
                    { staticClass: "share-video-proof-modal__loading" },
                    [
                      _c("b-spinner", { attrs: { small: "" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Loading proof…")]),
                    ],
                    1
                  )
                : [
                    _c(
                      "div",
                      { staticClass: "share-video-proof-modal__options" },
                      [
                        _c(
                          "label",
                          { staticClass: "share-video-proof-modal__check" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.notifyActivity,
                                  expression: "notifyActivity",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.notifyActivity)
                                  ? _vm._i(_vm.notifyActivity, null) > -1
                                  : _vm.notifyActivity,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.notifyActivity,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.notifyActivity = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.notifyActivity = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.notifyActivity = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "share-video-proof-modal__check-box",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "share-video-proof-modal__check-icon",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: { d: "M20 6 9 17l-5-5" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(
                              "\n            Notify me of proof activity\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "share-video-proof-modal__notify-others",
                          },
                          [
                            _c(
                              "label",
                              { staticClass: "share-video-proof-modal__check" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.notifyOthers,
                                      expression: "notifyOthers",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.notifyOthers)
                                      ? _vm._i(_vm.notifyOthers, null) > -1
                                      : _vm.notifyOthers,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.notifyOthers,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.notifyOthers = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.notifyOthers = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.notifyOthers = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "share-video-proof-modal__check-box",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "share-video-proof-modal__check-icon",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: { d: "M20 6 9 17l-5-5" },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n              Notify others…\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.notifyOthers
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "share-video-proof-modal__notify-others-body",
                                  },
                                  [
                                    _c("b-form-tags", {
                                      staticClass:
                                        "share-video-proof-modal__tags",
                                      attrs: {
                                        "input-id": "share-video-proof-emails",
                                        placeholder: "Add email addresses",
                                        "invalid-tag-text": "Invalid email(s)",
                                        "remove-on-delete": "",
                                        "add-on-change": "",
                                        "add-on-blur": true,
                                        separator: " ,;",
                                        "tag-validator": _vm.isValidEmail,
                                      },
                                      model: {
                                        value: _vm.notifyOthersEmails,
                                        callback: function ($$v) {
                                          _vm.notifyOthersEmails = $$v
                                        },
                                        expression: "notifyOthersEmails",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.visibleRecentRecipients.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "share-video-proof-modal__recents",
                                          },
                                          _vm._l(
                                            _vm.visibleRecentRecipients,
                                            function (email) {
                                              return _c(
                                                "div",
                                                {
                                                  key: email,
                                                  staticClass:
                                                    "share-video-proof-modal__recent",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "share-video-proof-modal__recent-add",
                                                      attrs: {
                                                        type: "button",
                                                        title: `Add ${email}`,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addRecentToEmails(
                                                            email
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(email) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "share-video-proof-modal__recent-remove",
                                                      attrs: {
                                                        type: "button",
                                                        "aria-label":
                                                          "Remove from recent recipients",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeRecent(
                                                            email
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                            width: "12",
                                                            height: "12",
                                                            viewBox:
                                                              "0 0 24 24",
                                                            fill: "none",
                                                            stroke:
                                                              "currentColor",
                                                            "stroke-width": "2",
                                                            "stroke-linecap":
                                                              "round",
                                                            "stroke-linejoin":
                                                              "round",
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d: "M18 6 6 18",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("path", {
                                                            attrs: {
                                                              d: "m6 6 12 12",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "share-video-proof-modal__check" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.requestApproval,
                                  expression: "requestApproval",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.requestApproval)
                                  ? _vm._i(_vm.requestApproval, null) > -1
                                  : _vm.requestApproval,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.requestApproval,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.requestApproval = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.requestApproval = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.requestApproval = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "share-video-proof-modal__check-box",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "share-video-proof-modal__check-icon",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: { d: "M20 6 9 17l-5-5" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(
                              "\n            Request approval\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.baseUrl
                      ? _c(
                          "div",
                          { staticClass: "share-video-proof-modal__link" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "share-video-proof-modal__link-label",
                              },
                              [_vm._v("Share a link")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "share-video-proof-modal__link-row",
                              },
                              [
                                _c("input", {
                                  ref: "copyTarget",
                                  staticClass:
                                    "share-video-proof-modal__link-input",
                                  attrs: { readonly: "" },
                                  domProps: { value: _vm.proofUrl },
                                  on: { click: _vm.copyLink },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "share-video-proof-modal__icon-btn",
                                    attrs: {
                                      type: "button",
                                      title: "Copy link",
                                      "aria-label": "Copy link",
                                    },
                                    on: { click: _vm.copyLink },
                                  },
                                  [_c("i", { staticClass: "fa fa-clipboard" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "share-video-proof-modal__icon-btn",
                                    attrs: {
                                      href: _vm.proofUrl,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      title: "Open link",
                                      "aria-label": "Open link",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-external-link-alt",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.copied
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "share-video-proof-modal__copied",
                                  },
                                  [
                                    _vm._v(
                                      "\n            Link copied to clipboard!\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "share-video-proof-modal__footer" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "share-video-proof-modal__btn-cancel",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v("\n            Cancel\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "share-video-proof-modal__btn-create",
                            attrs: { type: "button", disabled: _vm.isSharing },
                            on: { click: _vm.createProof },
                          },
                          [
                            _vm.isSharing
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v("\n            Create Proof\n          "),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }